import { signal } from '@angular/core';
import { FieldTree, min, required, SchemaPathTree } from '@angular/forms/signals';
import { SpacingDto } from '../../../../core/mceapi.client.generated';
import { match, none, Option, some } from '../../../../shared/functions/functional';

export enum SpacingCase {
  Touching = 'Touching',
  OneDiameter = 'OneDiameter',
  TwoDiameters = 'TwoDiameters',
  EdgeToEdge = 'EdgeToEdge',
}

export type SpacingValue = SpacingCase | '';

export const SpacingCases = [
  { value: SpacingCase.Touching, label: 'Touching' },
  { value: SpacingCase.OneDiameter, label: 'One Diameter' },
  { value: SpacingCase.TwoDiameters, label: 'Two Diameters' },
  { value: SpacingCase.EdgeToEdge, label: 'Edge to Edge' }
];

export interface Spacing {
  case: SpacingValue;
  edgeToEdge: number;
}

export function defaultSpacing(): Spacing {
  return {
    case: SpacingCase.TwoDiameters,
    edgeToEdge: 0.3,
  };
}

export function buildSpacingSchema(path: SchemaPathTree<Spacing>) {

  required(path.edgeToEdge, { message: `Edge to edge length is required` });
  min(path.edgeToEdge, 0, { message: `Edge to edge length must be positive` });

}

export function createSpacing(dto: Option<SpacingDto>) {
  return signal<Spacing>(
    match(
      (): Spacing => ({ case: '', edgeToEdge: 0 }),
      (x: SpacingDto): Spacing => {
        if (x.case === undefined || x.edgeToEdge === undefined) {
          throw new Error('Spacing DTO is missing required values.');
        }

        return { case: x.case as SpacingValue, edgeToEdge: x.edgeToEdge };
      }
    )(dto));
}

export function createSpacingDto(model: FieldTree<Spacing>) {
  return signal<Option<SpacingDto>>(
    model.case().value() === ''
      ? none
      : some({ case: model.case().value(), edgeToEdge: model.edgeToEdge().value() })
  );
}
